"use strict";

var _regeneratorRuntime = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConfigLoader = void 0;

var timers_1 = require("./timers");

var SECONDS_PER_MINUTE = 60;
var DEFAULT_CONFIG_REFRESH_MINUTES = 10; // minimum minutes until configuration is refreshed

var DEFAULT_CONFIG_REFRESH_SECONDS = DEFAULT_CONFIG_REFRESH_MINUTES * SECONDS_PER_MINUTE;
/**
 * Deadline implements a simple timer reporting when it's time to refresh config.
 */

var Deadline = /*#__PURE__*/function () {
  function Deadline(intervalMs) {
    _classCallCheck(this, Deadline);

    this.start = Date.now();
    this.interval = intervalMs;
  }
  /**
   * Return true if the deadline has passed.
   *
   * @returns {boolean} isPassed
   */


  _createClass(Deadline, [{
    key: "isPassed",
    value: function isPassed() {
      if (this.deltaNow() > this.interval) {
        this.reset();
        return true;
      }

      return false;
    }
  }, {
    key: "deltaNow",
    value: function deltaNow() {
      var now = Date.now();
      return now - this.start;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.start = Date.now();
    }
  }]);

  return Deadline;
}();
/**
 * Return an async "getConfig" function that loads config from the provided
 * callback function.
 *
 * @param {Function} loadConfigFn
 *
 * @returns {Function} getConfigFn
 */


function createConfigLoader(_ref) {
  var loadConfigFn = _ref.loadConfigFn,
      _ref$refreshIntervalS = _ref.refreshIntervalSeconds,
      refreshIntervalSeconds = _ref$refreshIntervalS === void 0 ? DEFAULT_CONFIG_REFRESH_SECONDS : _ref$refreshIntervalS;
  var deadline = new Deadline(refreshIntervalSeconds * timers_1.MILLISECONDS_PER_SECOND);
  var config;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(config && !deadline.isPassed())) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", config);

          case 2:
            config = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      return _context.abrupt("return", loadConfigFn());

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
            return _context2.abrupt("return", config);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.createConfigLoader = createConfigLoader;